  document.addEventListener("DOMContentLoaded", function () {
    const thumbs = document.querySelectorAll(".video-thumb");
    const mainVideo = document.getElementById("mainVideo");
    const mainTitle = document.getElementById("mainTitle");

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const videoId = thumb.getAttribute("data-id");

        // Corrected selector
        const titleElement = thumb.parentElement.querySelector(".video-title");
        const title = titleElement ? titleElement.textContent : "";

        mainVideo.src = `https://www.youtube.com/embed/${videoId}`;
        mainTitle.textContent = title;
      });
    });
  });